import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CreateStockDTO, Stock, StockItemDTO, StockItemDTOForCustomer } from './domain/stock';
import { OrderItemDetailsDTO } from './domain/OrderItemDetails';
import { CustomerWithStockItems } from './domain/customer-with-stock';

@Injectable({
  providedIn: 'root'
})
export class StockService {
  private PATH = "/appliances/api/v2/stock";
  private ITEMSPATH = "/appliances/api/v2/stockItem";

  constructor(private http: HttpClient) { }

  getStocks(): Observable<Stock[]> {
     const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<Stock[]>(this.PATH , {headers});
  }

  addStock(stock: CreateStockDTO): Observable<Stock> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<Stock>(this.PATH, stock , {headers});
  }

  updateStock(id: number, stock: CreateStockDTO): Observable<Stock> {
    const url = `${this.PATH}/${id}`;
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put<Stock>(url, stock , {headers});
  }



  findStockItemsByStockId(stockId: number): Observable<StockItemDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<StockItemDTO[]>(`${this.ITEMSPATH}/${stockId}` , {headers});
  }

  updateStockItems(stockItems: StockItemDTO[]): Observable<StockItemDTO[]> {
    const url = `${this.ITEMSPATH}/updateMultiple`;
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put<StockItemDTO[]>(url, stockItems , {headers});
  }
  updateStockItemsForCustomer(stockItems: StockItemDTOForCustomer[]): Observable<StockItemDTOForCustomer[]> {
    const url = `${this.ITEMSPATH}/updateMultiple`;
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put<StockItemDTOForCustomer[]>(url, stockItems , {headers});
  }

 getStockByProductId(productId : any ): Observable<Stock[]>  {
  const token = localStorage.getItem("token");
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<Stock[]>(this.PATH +'/stockbyproductid', productId , {headers});
  }

  getOrderItems(orderId: number): Observable<StockItemDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<StockItemDTO[]>(`${this.ITEMSPATH}/orderItems/${orderId}` , {headers});
  }

  getStockItemsByCustomerId(customerId: number): Observable<StockItemDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<StockItemDTO[]>(`${this.ITEMSPATH}/customer/${customerId}` , {headers});
  }

  getAllCustomerStockItems(): Observable<StockItemDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<StockItemDTO[]>(`${this.ITEMSPATH}/customer/all` , {headers});
  }

  getLastTenStocks(): Observable<Stock[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<Stock[]>(this.PATH + '/lasttenstocks' , {headers});
  }

  getMasterOrderItems(orderId: number): Observable<StockItemDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<StockItemDTO[]>(`${this.ITEMSPATH}/masterOrderItems/${orderId}` , {headers});
  }
  updateOrderItemDetails(orderItemDetails: OrderItemDetailsDTO): Observable<void> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put<void>(`${this.ITEMSPATH}/updateOrderItemDetails`, orderItemDetails , {headers});
  }


  getOldDateStockItems(ids : any): any {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(this.ITEMSPATH + '/orderItemsDates', ids , {headers});
  }
  getStockItemsByStockIds(stockIds: number[]): Observable<StockItemDTO[]> {
    const url = `${this.ITEMSPATH}/byStockIds`;
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<StockItemDTO[]>(url, stockIds, { headers });
  }
 

  getCustomersWithStockItems(): Observable<CustomerWithStockItems[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<CustomerWithStockItems[]>("/appliances/api/v2/customers/with-stock-items", {headers});
  }

}
